import { render } from "./SeoServicePage.vue?vue&type=template&id=e4b585ba&scoped=true"
import script from "./SeoServicePage.vue?vue&type=script&lang=js"
export * from "./SeoServicePage.vue?vue&type=script&lang=js"

import "./SeoServicePage.vue?vue&type=style&index=0&id=e4b585ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4b585ba"]])

export default __exports__